import React from "react";
import {
	Box, CardContent,
	IconButton, Stack, Typography,
} from "@mui/material";
import { Document } from "../../models/Document";
import moment from "moment/moment";
import {styled} from "@mui/material/styles";
import {translateFunction} from "../../../../localization/TranslationService";
import {MetaObject} from "../../models/MetaObject";
import {AuditSource} from "../../models/AuditSource";
import {OpenInNew} from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const translate = translateFunction("SureBaseDocuments");
interface IDocumentCardProps {
	document?: Document;
}

export const DocumentCard: React.FC<IDocumentCardProps> = ({ document}) => {
	const Item = styled(Box)(({ theme }) => ({
		backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
		...theme.typography.body2,
		//padding: theme.spacing(1),
		textAlign: "left",
		color: theme.palette.text.secondary,
	}));
	
	
	if (!document) {
		return <></>;
	}
	const metaObject = new MetaObject(document.metaData);
	const splitted = document.audits?.filter((it) => it.source === AuditSource.Splitter );
	const mailed =document.audits?.filter((it) => it.source === AuditSource.Mailer );
	return (
		<CardContent>
			{(( splitted && splitted.length > 0)  || (mailed && mailed.length > 0 )) &&
				<>
					<Accordion>
						<AccordionSummary  expandIcon={<ExpandMoreIcon />}><Item>{translate("Related documents")}</Item></AccordionSummary>
						<AccordionDetails>
							{splitted?.map((it) => {
								const id = it.message?.match(/(?<=\[)([^\]]+)(?=])/)?.firstOrNull();
	
								return (
									<Item>
										{it.message}
										{id &&
							<IconButton href={"/documents/" + id} target="_blank"><OpenInNew/></IconButton>
										}
									</Item>
								);
							})}
							{mailed?.map((it) => {
								const id = it.message?.match(/(?<=\[)([^\]]+)(?=])/)?.firstOrNull();
								
								return (
									<Item key = {it.id}>
										{it.message}
										{id &&
											<IconButton href={"/documents/" + id} target="_blank"><OpenInNew/></IconButton>
										}
									</Item>
								
								);
							})}
						
						</AccordionDetails>
					</Accordion>
				</>
			}
			<Stack direction="column">
				<Typography>{translate("Created")} : {moment(document.created).format("DD-MM-YYYY HH:mm:ss")}</Typography>
				<Typography>{translate(metaObject.mailSubject ? "Subject" : "Description")} : {metaObject.mailSubject??document.description}</Typography>
				{metaObject.mailSender && <Typography>{translate("From")} : {metaObject.mailSender}</Typography>}
				{metaObject.mailReplyTo.length > 0 && <Typography>{translate("Reply To")} : {metaObject.mailReplyTo.join("; ")}</Typography>}
				{metaObject.mailTo.length > 0 && <Typography>{translate("To")} : {metaObject.mailTo.join("; ")}</Typography>}
				{metaObject.mailCc.length > 0 && <Typography>{translate("Cc")} : {metaObject.mailCc.join("; ")}</Typography>}
			</Stack>
		</CardContent>
	);
};


